import { createFileRoute } from "@tanstack/react-router";
import Refresh from "@repo/icons/default/Refresh";
import { Page } from "@/components/ui/layout/page/page";
import { HeaderRoot, HeaderTitle } from "@/components/ui/layout/header/header";
import {
  EmptyStateButton,
  EmptyStateDescription,
  EmptyStateIcon,
  EmptyStateRoot,
  EmptyStateTitle,
} from "@/components/ui/empty-state/empty-state";
import { storeUrlByPlatform } from "@/lib/utils/config";

import type { JSX } from "react";

const UpdateRequiredPage = (): JSX.Element => {
  return (
    <>
      <HeaderRoot>
        <HeaderTitle title="Livance" align="center" />
      </HeaderRoot>
      <Page>
        <EmptyStateRoot>
          <EmptyStateIcon fill="secondary" icon={Refresh} />
          <EmptyStateTitle>Nova atualização disponível</EmptyStateTitle>
          <EmptyStateDescription>
            Uma nova atualização está disponível para download. Atualize agora para
            acessar os recursos mais recentes.
          </EmptyStateDescription>
          {/* TODO: Esse botão tem que ser vermelho quando o CPSButton permitir */}
          <EmptyStateButton
            onClick={() => {
              window.open(storeUrlByPlatform(), "_blank")?.focus();
            }}
            fullWidth
          >
            Atualizar aplicativo
          </EmptyStateButton>
        </EmptyStateRoot>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/update-required/")({
  component: UpdateRequiredPage,
});
